import React, { Component } from 'react';
import Grid from '@react/react-spectrum/Grid/js/Grid';
import GridColumn from '@react/react-spectrum/Grid/js/GridColumn';
import GridRow from '@react/react-spectrum/Grid/js/GridRow';
import Heading from '@react/react-spectrum/Heading';
import { Translate } from 'react-redux-i18n';
import { getFormValues, reduxForm } from 'redux-form';
import { connect } from 'react-redux';


class Finish extends Component {

    render() {
        return <div>
            <Grid>
                <GridRow>
                    <GridColumn size={[12, 10, 8, 8]} offsetSize={[0, 1, 2, 2]}>
                        <GridRow>
                            <GridColumn >
                                <Heading className="textBold" variant="pageTitle"><Translate value="uplevelRenewal.thank_you" /></Heading>
                                {this.props.formStates.context === "Uplevel" ?
                                   <div><p><Translate value="uplevelRenewal.OnbrdThankYouUplevelCertGold" /></p>
                                        {this.props.formStates.geo == 'Americas' || this.props.formStates.geo == 'LatinAmerica' ?
                                            <p>
                                                (US and Canada only)If you are applying to upgrade to the Gold level of the Reseller Program, and you currently hold a specialization, you must provide the contact name of an additional Adobe Certified Sales Professional for your specialization. Please update your Sales Center contacts to indentify this additional Adobe Certified Sales Professional.<br />
                                            </p> :
                                            null
                                        }
                                    </div> : 
                                    <p><Translate value="uplevelRenewal.OnbrdThankYouRenewalCertGold"/></p>
                                }
                                <p><Translate value="uplevelRenewal.OnbrdThankYouHelpDesk" /></p>
                            </GridColumn>
                        </GridRow>
                    </GridColumn>
                </GridRow>
            </Grid>
        </div>
    }
}

Finish = reduxForm({
    form: 'uplevelRenewal',
    destroyOnUnmount: false, //        <------ preserve form data
    forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
})(Finish);

function mapStateToProps(state) {
    return {
        formStates: getFormValues('uplevelRenewal')(state), // here 'form' is the name you have given your redux form  
    }
}
export default connect(mapStateToProps)(Finish);